import { Loader2 } from "lucide-react";

export function FullScreenLoader() {
  return (
    <div className="fixed inset-0 z-9999 bg-black/10 backdrop-blur-sm">
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 size={42} className="animate-spin text-primary" />
      </div>
    </div>
  );
}
